interface DevModeBannerProps {
  label: string;
  counts: string;
}

export function DevModeBanner({ label, counts }: DevModeBannerProps) {
  const scenarios = [
    { value: 'standard', label: 'standard', desc: '4 active, 20 archived' },
    { value: 'heavy', label: 'heavy', desc: '100 archived' },
    { value: 'new', label: 'new', desc: 'empty state' },
    { value: 'scenarios', label: 'scenarios', desc: 'one per state' },
  ];

  const switchScenario = (scenario: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set('dev', scenario);
    window.location.assign(url.toString());
  };

  const exitDevMode = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('dev');
    window.location.assign(url.toString());
  };

  return (
    <div className="bg-amber-500/10 border-b border-amber-500/20">
      <div className="max-w-4xl mx-auto px-6 py-2">
        <div className="flex items-center justify-between gap-4">
          {/* Left: Current mode info */}
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1.5">
              <div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
              <span className="text-xs font-mono font-medium text-amber-700 dark:text-amber-400 uppercase">
                dev:{label}
              </span>
            </div>
            <span className="text-xs text-amber-600/70 dark:text-amber-500/70">
              {counts}
            </span>
          </div>

          {/* Right: Scenario switcher */}
          <div className="flex items-center gap-2">
            {scenarios.map((s) => (
              <button
                key={s.value}
                onClick={() => switchScenario(s.value)}
                className={`px-2 py-1 text-xs font-mono rounded transition-colors ${
                  label === s.value
                    ? 'bg-amber-500/20 text-amber-700 dark:text-amber-400'
                    : 'text-amber-600/60 dark:text-amber-500/60 hover:text-amber-700 dark:hover:text-amber-400 hover:bg-amber-500/10'
                }`}
                title={s.desc}
              >
                {s.label}
              </button>
            ))}
            <div className="w-px h-4 bg-amber-500/20 mx-1" />
            <button
              onClick={exitDevMode}
              className="px-2 py-1 text-xs text-amber-600/60 dark:text-amber-500/60 hover:text-amber-700 dark:hover:text-amber-400 transition-colors"
              title="Exit dev mode"
            >
              exit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
